<template>
    <div>
        <div class="box-shadow pad-1 mb-16">
            <el-form ref="form" :model="form" class="boc-form" label-width="120px">
                <el-form-item label="活动名称" prop="name">
                    <el-input v-model="form.name" placeholder="请输入单位名称"></el-input>
                </el-form-item>
                <!-- <el-form-item label="开始时间" prop="startTime">
                    <el-date-picker v-model="form.startTime" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date"
                        placeholder="请选择开始时间" @change="selectTime">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="结束时间" prop="endTime">
                    <el-date-picker v-model="form.endTime" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date"
                        placeholder="请选择结束时间" @change="selectTime1">
                    </el-date-picker>
                </el-form-item> -->
                <el-form-item label="活动开始时间" prop="startTime">
                    <el-date-picker v-model="form.startTime" type="daterange" range-separator="至" format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期"
                        @change="selectTime">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <div class="check pad-16 mb-24">
                <div class="check-1">
                    <p class="check-p">地域</p>
                    <div class="check-1-p">
                        <p v-for="(ite,inde) in proviceList" :key="inde" @click="proClick(inde,ite.provinceName)"
                            :class="proIndex == inde ?'selected':'delAll'">
                            {{ite.provinceName}}
                        </p>
                    </div>
                </div>
                <div class="check-1" style="margin-bottom: 0;">
                    <p class="check-p">活动状态</p>
                    <div class="check-1-p">
                        <p :class="isIndex == inde ?'selected':'delAll'" v-for="(ite,inde) in activityList" :key="inde"
                            @click="isNoClick(inde,ite.activityStatus)">
                            {{ite.name}}
                        </p>
                    </div>
                </div>
            </div>
            <div class="flex-1 jus-bet">
                <div></div>
                <div class="flex-1 tishis">
                    <p @click="handleClose">取消</p>
                    <p @click="secarch">确定</p>
                </div>
                <div></div>

            </div>
        </div>
        <div class="box-shadow pad-1">
            <div class="flex-1 cursor mt-32" v-for="(item,index) in expertList" :key="index">
                <div class="tttile" @click="detail(item.id)">
                    <img :src="item.coverImage" alt="" class="hed-img">
                    <!-- <p class="first">待开始</p> -->
                    <p :class="item.activityStatus==1000?'first-1':item.activityStatus==2000?'first-2':'first-3'" class="first">
                        {{item.activityStatus==1000?'待参加':item.activityStatus==2000?'进行中':'已结束'}}
                    </p>
                </div>
                <div style="padding-right: 48px;" class="wid-100">
                    <div class="flex-1 just-bet mb-8">
                        <p class="name-1">{{item.name}}</p>
                    </div>
                    <div class="flex-1 just-bet mb-8" style="align-items: baseline;">
                        <p class="name-2">培训简介:</p>
                        <p class="name-3">
                            {{item.intro}}
                        </p>
                    </div>
                    <div class="flex-1 just-bet" style="margin-bottom: 22px;">
                        <p class="name-2">培训时间:</p>
                        <p class="name-3">
                            {{utils.getNowTime(item.startTime)}}-{{utils.getNowTime(item.endTime)}}
                        </p>
                    </div>
                </div>
                <div class="mt-23" @click="info(item.id)">
                    <div class="online">
                        报名信息
                    </div>
                </div>
            </div>
            <el-pagination v-show="pageInline.tableTotal>0" @size-change="handleSizeChange"
                @current-change="handleCurrentChange" :page-sizes="pageGroup.sizes" :page-size="pageGroup.size"
                layout="total, sizes, prev, pager, next, jumper" :total="pageInline.tableTotal">
            </el-pagination>
        </div>

    </div>
</template>

<script>
    import city from '@/components/city.json';
    import {
        getMyActivity,
    } from '@/api/personal/api.js';
    export default {
        components: {},
        data() {
            return {
                activeName: '',
                expertList: [],
                currentPage4: 4,
                form: {
                    name: '',
                    startTime: '',
                    endTime: '',
                },
                proviceList: city.data,
                num: 0,
                showAllSelected: false,
                // 活动状态
                activityList: [{
                        name: '待参加',
                        checked: false,
                        activityStatus: 1000,
                    },
                    {
                        name: '进行中',
                        checked: false,
                        activityStatus: 2000,
                    },
                    {
                        name: '已结束',
                        checked: false,
                        activityStatus: 3000,
                    }
                ],
                isNoShow: true,
                isIndex: -1,
                proIndex: -1,
                page: 1,
                limit: this.pageGroup.size,
                //分页对象
                pageInline: {
                    tableSizes: this.pageGroup.sizes, //显示条数分组
                    tableTotal: 10, // 默认数据总数
                },
                activityStatus: '',
                startTime: '',
                endTime: ''
            }
        },
        created() {},
        mounted() {
            console.log(this.$route.params.types)
            if (this.$route.params.types == 1) {
                this.getInit();
            }
        },
        methods: {
			detail(id) {
				this.$router.push({
					name: 'activityDetail',
					params: {
						id: id,
						footersType:1,
					}
				})
			},
            getInit() {
                let params = {
                    pageNo: this.page,
                    pageSize: this.pageGroup.size,
                    name: this.form.name,
                    startTime: this.startTime,
                    activityStatus: this.activityStatus,
                    location: this.location,
                }

                getMyActivity(params).then(res => {
                        this.expertList = res.data.list;
                        this.pageInline.tableTotal = res.data.total;
                    })
                    .catch(error => {

                    });
            },
            handleSizeChange(val) {
                console.log(`每页 ${val} 条`);
            },
            handleCurrentChange(val) {
                console.log(`当前页: ${val}`);
            },
            info(id) {
                this.$router.push({
                    name:'/activity/information',
                    params:{
                        id:id
                    }
                })
            },
            handleClose() {
                this.form.name = '';
                this.form.startTime = '';
                this.activityStatus = '';
                this.location = '';
                this.proIndex = -1;
                this.isIndex = -1;
                this.getInit();
            },
            secarch() {
                let arr = [this.startTime, this.endTime];
                this.startTime = arr.join(",")
                console.log(this.startTime, 'this.startTime')
                this.getInit();
            },
            // 省份
            proClick(index) {
                this.proIndex = index;
                this.location = this.proviceList[index].provinceName
                this.getInit();
            },
            isNoClick(index) {
                this.isIndex = index;
                this.activityStatus = this.activityList[index].activityStatus;
                this.getInit();
                // console.log(this.activityStatus,'this.activityStatus')
            },
            //页容量改变时会触发
            handleSizeChange(size) {
                this.limit = size;
                this.getInit();
            },
            //当前页改变时会触发
            handleCurrentChange(currentPage) {
                console.log(currentPage, 'currentPage')
                this.page = currentPage;
                this.getInit();
            },
            selectTime(value) {
                console.log(value)
                this.startTime = value.join(",")
                console.log(this.startTime, 'this.startTime')
                // this.startTime = value +' '+'00:00:00';
                // let timestampStr = value.slice(5);
                // 创建日期对象并获取时间戳
                // let timestamp = new Date(timestampStr).getTime();
                // console.log(timestamp); // 输出结果为时间戳值
                // this.startTime = timestamp;
            },
            selectTime1(value) {
                console.log(value)
                // let timestampStr = value.slice(5);
                // 创建日期对象并获取时间戳
                // let timestamp = new Date(timestampStr).getTime();
                // console.log(timestamp); // 输出结果为时间戳值
                this.endTime = value + ' ' + '00:00:00';
            }
        }
    }
</script>

<style scoped>
    .box-shadow {
        box-shadow: 2px 2px 8px 0px rgba(195, 219, 255, 0.25);
        border-radius: 8px 8px 8px 8px;
    }

    .pad-1 {
        padding: 16px;
    }

    .flex-1 {
        display: flex;
        align-items: center;
    }

    .jus-bet {
        justify-content: space-between;
    }

    .mb-24 {
        margin-bottom: 24px;
    }

    .mb-16 {
        margin-bottom: 16px;
    }

    /deep/.boc-tab .el-tabs__item {
        color: #222222;
        font-size: 14px;
        width: 34%;
        padding-right: 0;
    }

    /deep/.boc-tab .el-tabs__item .is-top .is-active {
        /* color: #3377FF; */
        /* background-color: #ffffff; */
    }

    /deep/.boc-tab .el-tabs__item .is-active {
        color: #3377FF !important;
        background-color: #ffffff !important;
    }

    /deep/.el-tabs__item.is-active {
        color: #3377FF !important;
    }

    /deep/.boc-tab .el-tabs__active-bar {
        width: 34% !important;
        bottom: 13%;
        background-color: #3377FF !important;
        /* transform:none!important; */
    }

    /deep/.boc-tab .el-tabs__nav-scroll {
        padding-left: 0;
        border-bottom: 1px solid #EFEFEF;
        height: 48px;
    }

    /deep/.boc-tab .el-tabs {
        width: 75%;
    }

    .boc-tab {
        position: relative;
    }

    .searvhs {
        position: absolute;
        right: 1rem;
        top: 10px;
    }

    .se-1 {
        border-radius: 51px 51px 51px 51px;
        border: 1px solid #EFEFEF;
        padding: 0.625rem 1rem;
        cursor: pointer;
    }

    .se-1 img {
        width: 1.125rem;
        height: 1.1875rem;
        padding-right: 0.625rem;
    }

    .se-1 p {
        font-size: 14px;
        color: #CCCCCC;
    }

    .tttile {
        position: relative;
    }

    .hed-img {
        width: 280px;
        height: 160px;
        padding-right: 16px;
    }

    .mb-8 {
        margin-bottom: 8px;
    }

    .name-1 {
        font-size: 20px;
        padding-right: 9px;
        padding-top: 35px;
    }

    .name-2 {
        color: #999999;
        font-size: 14px;
        white-space: nowrap;
        padding-right: 8px;
    }

    .name-3 {
        font-size: 14px;
        font-weight: normal;
    }

    /deep/.el-pagination {
        text-align: center;
    }

    .online {
        font-size: 14px;
        color: #3377FF;
        padding: 8px 16px;
        background: #F0F5FF;
        white-space: nowrap;
        border-radius: 35px 35px 35px 35px;
    }

    .mt-32 {
        margin-top: 32px;
    }

    .first{
        position: absolute;
        left: 0;
        top: 0;
        font-size: 14px;
        font-weight: normal;
        border-radius: 4px 16px 4px 16px;
        padding: 4px 16px;
    }
    .first-1 {
        color: #FBB54C;
        background: #FFF6F0;
    }
    .first-2 {
        color: #3ECC64;
        background: #EBFAEF;
    }
    .first-3 {
        color: #FF534D;
        background: #FFF0F0;
    }

    .boc-form {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
    }


    /deep/.boc-form .el-form-item__label {
        padding-right: 16px;
        color: #222222;
        font-size: 14px;
    }

    .check {
        /* width: 100%; */
        /* height: 352px; */
        background: #FAFAFA;
        border-radius: 4px 4px 4px 4px;
        color: #222222;
        padding: 16px 0;
    }

    .check-1 {
        display: flex;
        /* align-items: center; */
        margin-bottom: 16px;
    }

    .check-1 p {
        padding: 4px 12px;
        font-size: 14px;
    }

    .check-1-p {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
    }

    .check-1-p p:first-child {
        /* color: #3377FF; */
        /* background: #F0F5FF; */
        /* border-radius: 8px 8px 8px 8px; */
    }

    .check-p {
        /* margin-right: 24px; */
        min-width: 74px;
    }

    .tishis p {
        font-size: 16px;
        padding: 12px 74px;
        border-radius: 4px 4px 4px 4px;
    }

    .tishis p:first-child {
        color: #3377FF;
        background-color: #F0F5FF;
        margin-right: 2.5rem;
    }

    .tishis p:last-child {
        color: #ffffff;
        background-color: #3377FF;
    }

    .selected {
        color: #3377FF;
        background: #F0F5FF;
        border-radius: 8px 8px 8px 8px;
    }

    .delAll {
        color: #222222;
    }
</style>
